import { mutate } from 'swr';
import axios from 'axios';
import { Notistack } from '@shared/components/Notistack/Notistack';
import { getError } from '@shared/utils/helpers';
import { SERVICES } from '@shared/constants/apiConfig';
import { IStateLenderDropdownUser } from './interfaces';

const path = `${SERVICES.USER}/statelenderuserrestriction`;

export const requestCreateStateUser = (stateUser: IStateLenderDropdownUser) => {
  return mutate(path, async() => {
    try {
      await axios.post(path, stateUser);
      Notistack.successMessage('State User - Created Successfully');
    } catch (err) {
      Notistack.generalError(getError(err));
    }
  });
};

export const requestUpdateStateUser = (stateUser: IStateLenderDropdownUser) => {
  return mutate(path, async() => {
    try {
      await axios.put(`${path}/${stateUser.id}`, stateUser);
      Notistack.successMessage('State User - Updated Successfully');
    } catch (err) {
      Notistack.generalError(getError(err));
    }
  });
};

export const requestDeleteStateUser = (stateUserID = '') => {
  return mutate(path, async() => {
    try {
      await axios.delete(`${path}/${stateUserID}`);
      Notistack.successMessage('State User - Deleted Successfully');
    } catch (err) {
      Notistack.generalError(getError(err));
    }
  });
};
